import { ThemeProvider } from "@emotion/react";
import Box from "@mui/material/Box";
import { createTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import BigNormalButton from 'components/atoms/Button/BigNormalButton';
import * as React from "react";
import useStyles from "./All.styles";

const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

interface ICreatorProps {
  loading?: boolean;
}

const Creator: React.FC<ICreatorProps> = ({loading}) => {
  const illustration = require("assets/Board/illustration_3.png");
  const header = require("assets/header.png");

  const classes = useStyles();

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
      <Box
          style={{
            position: "absolute",
          }}
        >
          <img src={header} alt={"img"} style={{height:"430px",width:"100%"}}/>
          </Box>
        <Box className={classes.body}>
          <Box className={classes.skipTextSection}>
            <Typography
              className={classes.detailText}
              style={{ paddingBottom: "0px" }}
            >
              skip
            </Typography>
          </Box>
          <Box className={classes.illustrationSection}>
            <img src={illustration} alt={"img"} />
          </Box>
          <Box className={classes.titleTextSection}>
            <Typography className={classes.titleText}>
              Your Creator Fund
            </Typography>
          </Box>
          <Typography className={classes.detailText}>
            Tired of not being rewarded for your hard work? Our creator fund is
            designed to award your efforts: all you have to do is stay active
            and meet the requirements every season.
          </Typography>
          <Box className={classes.buttonSection}>
            <BigNormalButton color={"yellow"} text={"Next"} />
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Creator;
